var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnnouncement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 13L4.57465 19.2985C4.61893 19.4757 4.64107 19.5643 4.66727 19.6416C4.92317 20.3971 5.60352 20.9283 6.39852 20.9933C6.4799 21 6.5712 21 6.75379 21C6.98244 21 7.09677 21 7.19308 20.9906C8.145 20.8983 8.89834 20.145 8.99066 19.193C9 19.0967 9 18.9824 9 18.7538V4.49997M17.5 12.5C19.433 12.5 21 10.933 21 8.99997C21 7.06698 19.433 5.49997 17.5 5.49997M9.25 4.49997H5.5C3.01472 4.49997 0.999998 6.51469 1 8.99998C1 11.4853 3.01472 13.5 5.5 13.5H9.25C11.0164 13.5 13.1772 14.4469 14.8443 15.3556C15.8168 15.8858 16.3031 16.1508 16.6216 16.1118C16.9169 16.0757 17.1402 15.9431 17.3133 15.7011C17.5 15.4401 17.5 14.918 17.5 13.8737V4.12626C17.5 3.08197 17.5 2.55982 17.3133 2.29886C17.1402 2.05687 16.9169 1.92427 16.6216 1.8881C16.3031 1.84909 15.8168 2.11417 14.8443 2.64433C13.1772 3.55309 11.0164 4.49997 9.25 4.49997Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement);
export default __webpack_public_path__ + "static/media/announcement.359db807.svg";
export { ForwardRef as ReactComponent };